import { Component } from '@theme/component';

/**
 * Drives the 2 views of a store card (blocks/store-locations-store.liquid): default
 * info, and the "Ver no mapa" embedded-map view — which itself has a "Como chegar"
 * accordion revealing the Google Maps/Waze links (only reachable from inside the map
 * view, not from the default view).
 */
class StoreCard extends Component {
  requiredRefs = ['defaultView'];

  #copyResetTimeout;

  toggleDirections() {
    const panel = this.refs.directionsPanel;
    if (!panel) return;

    const willOpen = panel.hidden;
    panel.hidden = !willOpen;
    this.refs.directionsTrigger?.setAttribute('aria-expanded', String(willOpen));
    this.refs.directionsCaret?.classList.toggle('is-open', willOpen);
  }

  showMap() {
    this.#setView('map');
  }

  showDetails() {
    this.#setView('default');
    this.#collapseDirections();
  }

  async copyAddress() {
    const address = this.dataset.address;
    if (!address) return;

    try {
      await navigator.clipboard.writeText(address);
      this.#flashCopied();
    } catch (error) {
      console.error(error);
    }
  }

  /** @param {'default' | 'map'} view */
  #setView(view) {
    if (this.refs.defaultView) this.refs.defaultView.hidden = view !== 'default';
    if (this.refs.mapView) this.refs.mapView.hidden = view !== 'map';
  }

  #collapseDirections() {
    const panel = this.refs.directionsPanel;
    if (!panel || panel.hidden) return;

    panel.hidden = true;
    this.refs.directionsTrigger?.setAttribute('aria-expanded', 'false');
    this.refs.directionsCaret?.classList.remove('is-open');
  }

  #flashCopied() {
    const label = this.refs.copyLabel;
    if (!label) return;

    const original = label.textContent;
    label.textContent = 'Endereço copiado!';
    window.clearTimeout(this.#copyResetTimeout);
    this.#copyResetTimeout = window.setTimeout(() => {
      label.textContent = original;
    }, 2000);
  }
}

customElements.define('store-card-component', StoreCard);
